import React, { useMemo } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { Grid } from "@material-ui/core";
import { selectCompany } from "../../redux/reducers/chart-reducer";
import { ChartTable } from "../ChartTable/ChartTable";
import { ChartGraph } from "../ChartGraph/ChartGraph";
import Loader from "../Loader/Loader";
import { chartDetailDataCorrector, getContractor } from "../../utils/chartDataCorrectors";
import { columnDefinition } from "./chartDetailColumns";
import { useState } from "react";
import { ChartSlider } from "../../components/ChartSlider/ChartSlider";
import { useRedirect } from "../../hooks/useRedirect";
import { RouteNames } from "../../router/consts";



export const ChartDetail = () => {
    const params = useParams();
    const { redirect } = useRedirect();
    const chartId = params.chartId;
    const { selectedCompany, loading } = useSelector(selectCompany);

    let data = null;
    let contractorName = null;

    const [slideData, setSlideData] = useState();

    if (selectedCompany && chartId) {
        data = chartDetailDataCorrector(selectedCompany, chartId);
        contractorName = getContractor(selectedCompany, chartId);
    }


    const changeState = (newData) => {

        if (newData)
        setSlideData(newData);
    
      }
    const columns = useMemo(
        () => columnDefinition,
        []
    );

    return data && !loading ? (
        <Grid container spacing={3} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
            <Grid item xs={12} sm={6} margin={1}>
                <ChartTable
                    data={data}
                    columns={columns}
                    chartDetail={true}
                    contractorName={contractorName}

                />
            </Grid>
            <Grid item xs={12} sm={6} margin={1}>
                <ChartGraph data={data} contractorName={contractorName} />
            </Grid>
            <Grid item xs={12} sm={12} md={6} margin={1}>
          <ChartSlider changeState = {changeState}/>
        </Grid>  
        </Grid>
    ) : (
        <Loader />
    );
};